import { render, staticRenderFns } from "./help_center.vue.js?vue&type=template&id=4f87deff!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./help_center.vue?vue&type=template&id=4f87deff"
import script from "./help_center.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./help_center.vue?vue&type=script&lang=js"
export * from "./help_center.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./help_center.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/gitlab-gdk/gitlab-development-kit/gitlab/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4f87deff')) {
      api.createRecord('4f87deff', component.options)
    } else {
      api.reload('4f87deff', component.options)
    }
    module.hot.accept("./help_center.vue.js?vue&type=template&id=4f87deff!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./help_center.vue?vue&type=template&id=4f87deff", function () {
      api.rerender('4f87deff', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "super_sidebar/components/help_center.vue"
export default component.exports